import { InjectionToken, makeEnvironmentProviders } from '@angular/core';

export type AppVersionGetter = () => string | null;

export const APP_VERSION_GETTER = new InjectionToken<AppVersionGetter>('CUE_APP_VERSION_GETTER');
export const APP_VERSION_LONG_PRESS_MS = new InjectionToken<number>('CUE_APP_VERSION_LONG_PRESS_MS');

export type AppVersionInfoOptions = {
  versionFactory: () => AppVersionGetter;
  longPressDurationMs?: number;
};

export function provideAppVersionInfo(options: AppVersionInfoOptions) {
  return makeEnvironmentProviders([
    {
      provide: APP_VERSION_GETTER,
      useFactory: options.versionFactory,
    },
    {
      provide: APP_VERSION_LONG_PRESS_MS,
      useValue: options.longPressDurationMs ?? 1200,
    },
  ]);
}
